import * as Yup from 'yup';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { messages } from './messages';

export const NicknameSchema = Yup.object({
  [FORM_REQUIREMENTS.NICKNAME]: Yup.string().required(() => ({
    messageDescriptor: messages.validationRequired,
  })),
});
